import { render, staticRenderFns } from "./ContentPrivacyPolicy.vue?vue&type=template&id=398263e6&"
import script from "./ContentPrivacyPolicy.vue?vue&type=script&lang=js&"
export * from "./ContentPrivacyPolicy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports